import type { JSX } from 'react'
import type { IActionButtonProps } from '../ActionButton'

import { ButtonColors, ButtonCorners, ButtonFonts } from 'atoms/Button'
import { IconNames } from 'atoms/Icon'
import { COLOR, INDENTS } from 'vars/index'
import { ActionButton } from '../ActionButton'
import { ActionButtonColors, ButtonBordersWidth } from '../ActionButton.h'

export const PrimaryBaseInlineRemoveButton = ({
  disabled,
  selected,
  icon = IconNames.remove,
  font = ButtonFonts.Button1,
  colorDefault = ActionButtonColors.COLOR_TEXT_SECONDARY,
  colorSelectedDefault = ActionButtonColors.COLOR_TEXT_SECONDARY,
  colorHovered = ActionButtonColors.TEXT_ICON_CONSTANT_LIGHT,
  colorSelectedHovered = ActionButtonColors.TEXT_ICON_CONSTANT_LIGHT,
  colorPressed = ActionButtonColors.COLOR_TEXT_SECONDARY,
  colorSelectedPressed = ActionButtonColors.COLOR_TEXT_SECONDARY,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.TRANSPARENT,
  backgroundColorDisabled = COLOR.TRANSPARENT,
  borderWidth = ButtonBordersWidth.BORDER_0,
  paddings = [INDENTS.INDENT_0],
  corners = ButtonCorners.CORNERS_10,
  ...rest
}: IActionButtonProps): JSX.Element => {
  return (
    <ActionButton
      icon={icon}
      font={font}
      selected={!!selected}
      disabled={!!disabled}
      colorDefault={colorDefault}
      colorSelectedDefault={colorSelectedDefault}
      colorHovered={colorHovered}
      colorSelectedHovered={colorSelectedHovered}
      colorPressed={colorPressed}
      colorSelectedPressed={colorSelectedPressed}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      paddings={paddings}
      corners={corners}
      {...rest}
    />
  )
}
